const prod = import.meta.env.PROD;
export const itineratorNetUrl = (slug, resource, path = "") => {
  const protocol = prod ? "https://" : "http://";
  const tld = prod ? ".net" : ".test:3001";
  return `${protocol}${slug}.itinerator${tld}/${resource}/${path}`;
};
